import React from 'react'

function CRMPipeline() {
  return (
    <div className='rounded-lg bg-white p-3 w-full' >CRMPipeline</div>
  )
}

export default CRMPipeline